// extracted by mini-css-extract-plugin
export default {"container":"cqrEmq","align-right":"vav1LY","align-left":"bJMRp8","align-justify":"ao8gcI","bare":"Hi_gAm","unit":"Q7AJIz"};